import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Functions from store
import {
  addLocationToWarehouse,
  deleteLocation,
  downloadLocationsByWarehouse,
  getAllCategories,
  getItemByLocation,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getLocationsByWarehouse,
  getSubModulesByRoleId,
  getWarehouseById,
  getZonesByWarehouseForViewLocation,
  uploadExcelForCreatingZoneRackLocation,
} from "../../store";

// Router Components
import { useParams } from "react-router-dom";

// @mui material components
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// React-Select component and styling
import Select from "react-select";
import Config from "../../config/index";
import "../../index.css";

import { CSVLink } from "react-csv";

// Notification
import { ToastContainer, toast } from "react-toastify";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Utils component
import TextError from "utils/TextError";

// Cookies
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForZoneModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 380, sm: 380, md: 800, lg: 1200, xl: 1200 },
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const ViewLocation = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  getLocationsByWarehouse,

  locationsByWarehouse,
  addLocationToWarehouse,
  deleteLocation,
  getItemByLocation,
  item,
  getWarehouseById,
  warehouseById,
  uploadExcelForCreatingZoneRackLocation,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevelReducer,

  getZonesByWarehouseForViewLocation,
  getZonesByWarehouseForViewLocationReducer,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,
  downloadLocationsByWarehouse,
  downloadLocationsByWarehouseReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let sfWarehouseModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "651dace4-07dc-4cb7-9fef-35782eebcf1e",
  );

  let viewLocations = sfWarehouseModule
    ? sfWarehouseModule.actionId.includes(
        "7fc2166f-9883-42e3-ad02-3bd4b088156e",
      )
    : null;

  let createLocations = sfWarehouseModule
    ? sfWarehouseModule.actionId.includes(
        "48c0e090-d58b-4001-83ec-ae7542208318",
      )
    : null;

  let deleteLocations = sfWarehouseModule
    ? sfWarehouseModule.actionId.includes(
        "7346a236-a50f-47f8-8929-1733c4c509cf",
      )
    : null;
  let uploadLocations = sfWarehouseModule
    ? sfWarehouseModule.actionId.includes(
        "c143bda4-f526-4161-87b6-1759477603c0",
      )
    : null;

  let downloadLocations = sfWarehouseModule
    ? sfWarehouseModule.actionId.includes(
        "2771c944-092b-4e4f-909a-cadee0b247b0",
      )
    : null;

  let addDirectLocation = sfWarehouseModule
    ? sfWarehouseModule.actionId.includes(
        "b844994c-0c28-444e-9ee3-a171fdbe884a",
      )
    : null;

  const navigate = useNavigate();

  const { warehouseId } = useParams();

  const [zonesListByWarehouseSelected, setZonesListByWarehouseSelected] =
    useState("");
  // useEffect(() => {
  //   getLevel2ByLevel(
  //     warehouseId,
  //     zonesListByWarehouseSelected?.value,
  //     jwtToken
  //   );
  // }, [warehouseId, zonesListByWarehouseSelected]);

  const handleChangeZonesListByWarehouse = (selectedOption) => {
    setZonesListByWarehouseSelected(selectedOption);
    setSectionsListByZoneSelected("");
    getLevel2ByLevel(warehouseId, selectedOption?.value, jwtToken);
  };

  const [zonesListByWarehouseOptions, setZonesListByWarehouseOptions] =
    useState([]);

  const [sectionsListByZoneSelected, setSectionsListByZoneSelected] =
    useState("");
  const handleChangeSectionsListByZone = (selectedOption) => {
    setSectionsListByZoneSelected(selectedOption);
  };

  const [sectionsListByZoneOptions, setSectionsListByZoneOptions] = useState(
    [],
  );

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        locationId: level.locationId,
      });
    });

    setSectionsListByZoneOptions(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  useEffect(() => {
    let tempZonesListByWarehouseOptions = [];
    let data = getZonesByWarehouseForViewLocationReducer.zones.data
      ? getZonesByWarehouseForViewLocationReducer.zones.data
      : [];

    data.map((zonesListByWarehouse) => {
      tempZonesListByWarehouseOptions.push({
        label: zonesListByWarehouse.locationName,
        value: zonesListByWarehouse.locationId,
      });
    });
    setZonesListByWarehouseOptions(tempZonesListByWarehouseOptions);
  }, [getZonesByWarehouseForViewLocationReducer]);

  useEffect(() => {
    getWarehouseById(warehouseId, jwtToken);
  }, [warehouseId]);

  useEffect(() => {
    getLevelsByWarehouse(warehouseId, jwtToken);
  }, [warehouseId]);

  // let levelOptions = [
  //   // {
  //   //   label: "Zone",
  //   //   value: 1,
  //   // },
  //   // {
  //   //   label: "Section",
  //   //   value: 2,
  //   // },
  //   // {
  //   //   label: "Rack",
  //   //   value: 3,
  //   // },
  //   {
  //     label: "location",
  //     value: 4,
  //   },
  // ];

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [zoneIdSelected, setZoneIdSelected] = useState("");

  const handleZoneIdChange = (selectedZone) => {
    setZoneIdSelected(selectedZone);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");

  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const [locationSelected, setLocationSelected] = useState("");

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  const [warehouseLocations, setWarehouseLocations] = useState([]);

  useEffect(() => {
    getZonesByWarehouseForViewLocation(warehouseId, jwtToken);
  }, [warehouseId]);
  useEffect(() => {
    getLocationsByWarehouse(warehouseId, jwtToken);
  }, [warehouseId]);

  useEffect(() => {
    downloadLocationsByWarehouse(warehouseId, jwtToken);
  }, []);

  useEffect(() => {
    setWarehouseLocations(locationsByWarehouse.locations.data);
    setLoading(locationsByWarehouse.loading);
  }, [locationsByWarehouse]);

  const [downloadData, setDownloadData] = useState([]);
  // console.log("downloadData", downloadData);
  // useEffect(() => {
  //   setDownloadData(
  //     downloadLocationsByWarehouseReducer?.locations?.data
  //       ? downloadLocationsByWarehouseReducer?.locations?.data
  //       : ""
  //   );
  // }, [downloadLocationsByWarehouseReducer]);

  useEffect(() => {
    let tempPicklist = [];

    // ✅ Ensure 'data' is always an array
    let data2 = downloadLocationsByWarehouseReducer;

    let data = Array.isArray(
      downloadLocationsByWarehouseReducer?.locations?.data,
    )
      ? downloadLocationsByWarehouseReducer.locations.data
      : [];

    data.map((picklist) => {
      const picklistObject = {
        privateKey: picklist.picklistCode,
        Warehouse: picklist.Warehouse,
        Zone: picklist.Zone,
        Section: picklist.Section,
        Rack: picklist.Rack,
        Location: picklist.Location,

        status: (
          <button
            className={
              (picklist.status === 0 && `status-created`) ||
              (picklist.status === 1 && `status-warning`) ||
              (picklist.status === 2 && `status-info`) ||
              (picklist.status === 3 && `status-info`) ||
              (picklist.status === 4 && `status-info`) ||
              (picklist.status === 5 && `status-success`)
            }
            style={{ width: "6.8rem" }}
          >
            {(picklist.status === 0 && `Created`) ||
              (picklist.status === 1 && `Released`) ||
              (picklist.status === 2 && `Picking`) ||
              (picklist.status === 3 && `Picked`) ||
              (picklist.status === 4 && `Delivering`) ||
              (picklist.status === 5 && `Delivered`)}
          </button>
        ),
        status2:
          (picklist.LocationStatus === 0 && `Occupied`) ||
          (picklist.LocationStatus === 1 && ` Empty`),
      };

      tempPicklist.push(picklistObject);
    });

    // setDownloadData(tempPicklist);
  }, [downloadLocationsByWarehouseReducer]);

  useEffect(() => {
    getLevel1ByLevel(warehouseId, 0, jwtToken);
  }, [warehouseId]);
  useEffect(() => {
    levelOptions[0]?.value === 2 && getLevel2ByLevel(warehouseId, 0, jwtToken);
  }, [warehouseId, levelOptions]);
  useEffect(() => {
    getLevel3ByLevel(warehouseId, 0, jwtToken);
  }, [warehouseId, levelOptions]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        locationId: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        locationId: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        locationId: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  useEffect(() => {
    getLevel4ByLevel(warehouseId, 0, jwtToken);
  }, [warehouseId]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [warehouseNameHeading, setWarehouseNameHeading] = useState("");

  useEffect(() => {
    setWarehouseNameHeading(warehouseById.warehouse[0]?.warehouseName);
  }, [warehouseById]);

  const [warehouseCodeHeading, setWarehouseCodeHeading] = useState("");
  const [loading2, setLoading2] = useState(true);

  useEffect(() => {
    setLoading2(warehouseById.loading);
    setWarehouseCodeHeading(warehouseById.warehouse[0]?.warehouseCode);
  }, [warehouseById]);

  const [isSuccessAddLocation, setIsSuccessAddLocation] = useState(false);
  const [isErrorAddLocation, setIsErrorAddLocation] = useState(false);
  const [isErrorMsgAddLocation, setIsErrorMsgAddLocation] = useState("");

  useEffect(() => {
    if (isErrorAddLocation) {
      setTimeout(() => {
        setIsErrorAddLocation(false);
      }, 3000);
    }
  }, [isErrorAddLocation]);

  useEffect(() => {
    if (isSuccessAddLocation) {
      setTimeout(() => {
        setIsSuccessAddLocation(false);
      }, 3000);
    }
  }, [isSuccessAddLocation]);

  const [addLocationModal, setAddLocationModal] = useState(false);
  const [locationData, setLocationData] = useState({});

  const handleAddLocationModal = (data = {}) => {
    setLocationData(data);
    setAddLocationModal(!addLocationModal);
    getLevel2ByLevel(warehouseId, "", jwtToken);
  };
  const handleCloseAddLocationModal = (data = {}) => {
    setAddLocationModal(false);
    getLevel2ByLevel(
      warehouseId,
      zonesListByWarehouseSelected?.value,
      jwtToken,
    );
  };

  const initialValue = {
    warehouseCode: "",
    parentId: "",
    rltId: "",
    isLocation: "",
    locationName: "",
    locationCode: "",
  };

  const validationSchema = Yup.object({
    location: Yup.string().required("Enter the Location"),
  });

  const onSubmitForAddLocation = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseId,

      parentId: locationData.locationId,
      rltId: 4,
      isLocation: 1,
      locationName: values.location,
      locationCode: `${locationData.locationCode}-${values.location}`,
    };

    let res = await addLocationToWarehouse(payload, jwtToken);
    if (res.status) {
      setIsSuccessAddLocation(true);
      getLocationsByWarehouse(warehouseId, jwtToken);
    }
    if (!res.status) {
      setIsErrorAddLocation(true);
      setIsErrorMsgAddLocation(res?.data?.data?.msg);
    }
    resetForm();
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: onSubmitForAddLocation,
    validationSchema: validationSchema,
  });

  const [itemDetailsModal, setOpenItemDetailsModal] = useState(false);

  const handleOpenItemDetailsModal = () => {
    setOpenItemDetailsModal(!itemDetailsModal);
  };

  const [itemTable, setItemTable] = useState({
    columns: [
      { Header: "Item Code/Des", accessor: "itemCodeDes", align: "left" },
      { Header: "SKU", accessor: "sku" },
      { Header: "SUID", accessor: "suid" },
      { Header: "LOT/Serial No", accessor: "lotSerialNo" },
      { Header: "vin No", accessor: "vinNo" },
      { Header: "FG Code", accessor: "fgCode" },
      { Header: "Quantity", accessor: "qty", align: "left" },
    ],
    rows: [],
  });

  const { columns, rows } = itemTable;

  const [locationName, setLocationName] = useState("");

  useEffect(() => {
    let tempItem = [];
    let data = item.item ? item.item : [];
    data.map((item) => {
      let itemDescription = item?.itemDescription;
      let len = desLength;
      const itemData = {
        suid: item.suid,
        sku: item.sku,
        vinNo: item.vinNo ? item.vinNo : "NA",
        fgCode: item.fgCode ? item.fgCode : "NA",

        itemCodeDes: `${item.itemCode} / ${
          itemDescription ? itemDescription.substring(0, len) : ""
        }`,
        qty: `${item.qty} ${item.uom}`,
        lotSerialNo: `${item.lotNumber ? item.lotNumber : "NA"} / ${
          item.serialNumber ? item.serialNumber : "NA"
        }`,
      };
      tempItem.push(itemData);
    });
    viewLocations && setItemTable({ ...itemTable, rows: tempItem });
  }, [item]);

  const notifyForUploadFile = (data) => {
    toast.success(data, {
      position: "top-center",
    });
  };
  const [ErrorMsg, setErrorMsg] = useState("");

  const notifyForUploadFileFailure = (data) => {
    toast.error(data, {
      position: "top-center",
      style: {
        width: "40rem",
        height: "20rem",
        lineHeight: "50px",
      },
    });
  };

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(true);
  };
  const uploadCsvFilterCloseHandler = () => {
    setUploadCsvFilter(false);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const [loading, setLoading] = useState(false);

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("files", uploadCsvData);

    let res = await uploadExcelForCreatingZoneRackLocation(data, jwtToken);
    if (res.statusCode == 200) {
      getLocationsByWarehouse(warehouseId, jwtToken);
      let data = `Data Submitted Successfully `;
      notifyForUploadFile(data);
      setUploadCsvFilter(false);
      setUploadCsvData({});
      setUploadCsvData("");
    }
    if (res.statusCode == 406) {
      setLoading(true);
      // setWarehouseData(res.data, jwtToken);
      setLoading(false);
    }
    if (!res.status) {
      notifyForUploadFileFailure(res?.data?.data?.msg);
    }
  };

  const [createErrorMsg, setCreateErrorMsg] = useState("");

  const [levelSelected, setLevelSelected] = useState("");

  const handleLevelChange = (selectedDocumentType) => {
    setLevelSelected(selectedDocumentType);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const [parentIdSelected, setParentIdSelected] = useState("");

  useEffect(() => {
    if (levelSelected?.value === 4) {
      (levelOptions[0]?.value === 3 ||
        levelOptions[1]?.value === 3 ||
        levelOptions[2]?.value === 3) &&
        setParentIdSelected(rackIdSelected?.locationId);

      levelOptions[0]?.value === 2 &&
        levelOptions.length === 2 &&
        setParentIdSelected(sectionIdSelected?.locationId);

      levelOptions[0]?.value === 1 &&
        levelOptions.length === 2 &&
        setParentIdSelected(zoneIdSelected?.locationId);
    }
    if (levelSelected?.value === 3) {
      levelOptions[0]?.value === 2 &&
        setParentIdSelected(sectionIdSelected?.locationId);

      levelOptions[0]?.value === 1 &&
        levelOptions[1]?.value !== 2 &&
        setParentIdSelected(zoneIdSelected?.locationId);

      levelOptions[1]?.value === 2 &&
        setParentIdSelected(sectionIdSelected?.locationId);
    }
    if (levelSelected?.value === 2) {
      // levelOptions[0]?.value === 1 &&
      setParentIdSelected(zoneIdSelected?.locationId);
    }
    if (levelSelected?.value === 1) {
      setParentIdSelected(0);
    }
  }, [levelSelected, rackIdSelected, sectionIdSelected, zoneIdSelected]);

  const [isSuccessAddZone, setIsSuccessAddZone] = useState(false);
  const [isErrorAddZone, setIsErrorAddZone] = useState(false);

  useEffect(() => {
    if (isErrorAddZone) {
      setTimeout(() => {
        setIsErrorAddZone(false);
      }, 3000);
    }
  }, [isErrorAddZone]);

  useEffect(() => {
    if (isSuccessAddZone) {
      setTimeout(() => {
        setIsSuccessAddZone(false);
      }, 3000);
    }
  }, [isSuccessAddZone]);

  const [addZoneModal, setAddZoneModal] = useState(false);
  const handleAddZoneModal = () => {
    setAddZoneModal(!addZoneModal);
    setLevelSelected("");
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    formikForAddZone.setValues(initialValueForAddZone);
    formikForAddZone.setErrors({});
  };

  const initialValueForAddZone = {
    location: "",
  };

  const validationSchemaForAddZone = Yup.object({
    location: Yup.string().required("Enter the level name"),
  });

  const onSubmitForAddZone = async (values, { resetForm }) => {
    let payload;
    if (levelSelected.value === 1) {
      payload = {
        warehouseId: warehouseId,

        parentId: parentIdSelected,
        rltId: levelSelected.value,
        isLocation: levelSelected.value === 4 ? 1 : 0,
        locationName: values.location,
        locationCode: `${warehouseId}-${values.location}`,
      };
    }

    if (levelSelected.value === 2) {
      payload = {
        warehouseId: warehouseId,

        parentId: parentIdSelected,
        rltId: levelSelected.value,
        isLocation: levelSelected.value === 4 ? 1 : 0,
        locationName: values.location,
        locationCode: `${warehouseId}-${zoneIdSelected.label}-${values.location}`,
      };
    }

    if (levelSelected.value === 3) {
      payload = {
        warehouseId: warehouseId,

        parentId: parentIdSelected,
        rltId: levelSelected.value,
        isLocation: levelSelected.value === 4 ? 1 : 0,
        locationName: values.location,
        locationCode: `${warehouseId}-${zoneIdSelected.label}-${sectionIdSelected.label}-${values.location}`,
      };
    }

    if (levelSelected.value === 4) {
      payload = {
        warehouseId: warehouseId,

        parentId: parentIdSelected,
        rltId: levelSelected.value,
        isLocation: levelSelected.value === 4 ? 1 : 0,
        locationName: values.location,
        locationCode: `${warehouseId}-${zoneIdSelected.label}-${sectionIdSelected.label}-${rackIdSelected.label}-${values.location}`,
      };
    }

    let res = await addLocationToWarehouse(payload, jwtToken);

    if (res.status) {
      setIsSuccessAddZone(true);
      getLocationsByWarehouse(warehouseId, jwtToken);
      getLevel1ByLevel(warehouseId, 0, jwtToken);
    }
    if (!res.status) {
      setIsErrorAddZone(true);
      setCreateErrorMsg(res?.data?.data?.msg);
    }
    resetForm();
  };

  const formikForAddZone = useFormik({
    initialValues: initialValueForAddZone,
    onSubmit: onSubmitForAddZone,
    validationSchema: validationSchemaForAddZone,
  });

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const [isSuccessRemoveLevel, setIsSuccessRemoveLevel] = useState(false);
  const [isErrorRemoveLevel, setIsErrorRemoveLevel] = useState(false);

  useEffect(() => {
    if (isErrorRemoveLevel) {
      setTimeout(() => {
        setIsErrorRemoveLevel(false);
      }, 3000);
    }
  }, [isErrorRemoveLevel]);

  useEffect(() => {
    if (isSuccessRemoveLevel) {
      setTimeout(() => {
        setIsSuccessRemoveLevel(false);
      }, 3000);
    }
  }, [isSuccessRemoveLevel]);

  const [removeLevelModal, setRemoveLevelModal] = useState(false);
  const handleRemoveLevelModal = () => {
    setRemoveLevelModal(!removeLevelModal);
    setLevelSelected("");
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
    formikForRemoveLevel.setValues(initialValueForRemoveLevel);
    formikForRemoveLevel.setErrors({});
    getLevel2ByLevel(warehouseId, "", jwtToken);
  };
  const handleCloseRemoveLevelModal = () => {
    setRemoveLevelModal(false);
    setLevelSelected("");
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
    formikForRemoveLevel.setValues(initialValueForRemoveLevel);
    formikForRemoveLevel.setErrors({});
    getLevel2ByLevel(warehouseId, "", jwtToken);
  };

  const initialValueForRemoveLevel = {
    location: "",
  };

  const validationSchemaForRemoveLevel = Yup.object({
    // location: Yup.string().required("Enter the level name"),
  });

  const onSubmitForRemoveLevel = async (values, { resetForm }) => {
    let payload;
    if (levelSelected.value === 1) {
      payload = {
        warehouseId: warehouseId,

        locationId: zoneIdSelected.value,
      };
    }

    if (levelSelected.value === 2) {
      payload = {
        warehouseId: warehouseId,

        locationId: sectionIdSelected.value,
      };
    }

    if (levelSelected.value === 3) {
      payload = {
        warehouseId: warehouseId,

        locationId: rackIdSelected.value,
      };
    }

    if (levelSelected.value === 4) {
      payload = {
        warehouseId: warehouseId,

        locationId: locationIdSelected.value,
      };
    }

    let res = await deleteLocation(payload.locationId, warehouseId, jwtToken);

    if (res.status) {
      setIsSuccessRemoveLevel(true);
      getLocationsByWarehouse(warehouseId, jwtToken);
      getLevel1ByLevel(warehouseId, 0, jwtToken);
    }
    if (!res.status) {
      setIsErrorRemoveLevel(true);
      setDeleteErrorMsg(res?.data?.data?.msg);
    }
    resetForm();
  };

  const formikForRemoveLevel = useFormik({
    initialValues: initialValueForRemoveLevel,
    onSubmit: onSubmitForRemoveLevel,
    validationSchema: validationSchemaForRemoveLevel,
  });

  // useEffect(() => {
  //   if (zonesListByWarehouseOptions) {
  //     setZonesListByWarehouseSelected({
  //       label: zonesListByWarehouseOptions[0]?.label,
  //       value: zonesListByWarehouseOptions[0]?.value,
  //     });
  //   }
  // }, [zonesListByWarehouseOptions]);

  // const [downloadData, setDownloadData] = useState([]);

  useEffect(() => {
    let tempPicklist = [];

    const rawData =
      downloadLocationsByWarehouseReducer?.locations?.data ||
      downloadLocationsByWarehouseReducer?.data ||
      downloadLocationsByWarehouseReducer ||
      [];

    const data = Array.isArray(rawData) ? rawData : [];

    data.forEach((picklist) => {
      const picklistObject = {
        Warehouse: picklist.Warehouse || "",
        Zone: picklist.Zone || "",
        Section: picklist.Section || "",
        Rack: picklist.Rack || "",
        Location: picklist.Location || "",
        status2:
          (picklist.LocationStatus === 0 && "Occupied") ||
          (picklist.LocationStatus === 1 && "Empty") ||
          "",
        // ✅ status as plain text (for CSV)
        status:
          (picklist.status === 0 && "Created") ||
          (picklist.status === 1 && "Released") ||
          (picklist.status === 2 && "Picking") ||
          (picklist.status === 3 && "Picked") ||
          (picklist.status === 4 && "Delivering") ||
          (picklist.status === 5 && "Delivered") ||
          "",
      };

      tempPicklist.push(picklistObject);
    });

    setDownloadData(tempPicklist);
    // console.log("tempPicklist", tempPicklist);
  }, [downloadLocationsByWarehouseReducer]);

  const headers = [
    {
      label: "Warehouse",
      key: "Warehouse",
    },
    {
      label: "Zone",
      key: "Zone",
    },
    {
      label: "Section",
      key: "Section",
    },
    {
      label: "Rack",
      key: "Rack",
    },
    {
      label: "Location",
      key: "Location",
    },
    // {
    //   label: "Status",
    //   key: "status2",
    // },
  ];

  const csvLink2 = {
    filename: "Locations list.csv",
    headers: headers,
    data: downloadData,
  };
  const csvLink = {
    filename: "Locations Template.csv",
    headers: headers,
    data: [],
  };

  // percent ko 0–100 ke beech clamp karne ke liye helper
  const clampPct = (v) => Math.max(0, Math.min(100, Number(v ?? 0)));

  return (
    <DashboardLayout>
      <DashboardNavbar previousPage={true} />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="left"
                p={3}
                mb={-1}
              >
                {/* <MDBox display="flex">
                  <MDTypography variant="h4" gutterBottom>
                    {warehouseNameHeading}
                  </MDTypography>
                </MDBox> */}

                <MDBox>
                  <MDBox
                    display="flex"
                    // flexDirection={{
                    //   xs: "column",
                    //   sm: "column",
                    //   md: "row",
                    //   lg: "row",
                    //   xl: "row",
                    // }}
                  >
                    {createLocations && (
                      <Tooltip title="Add Level">
                        <MDButton
                          color="info"
                          iconOnly
                          variant="contained"
                          type="button"
                          size="small"
                          onClick={() => {
                            setAddZoneModal(true);
                          }}
                          style={{
                            margin: "10px",
                            marginLeft: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
                          }}
                        >
                          <Icon>add</Icon>
                        </MDButton>
                      </Tooltip>
                    )}

                    {deleteLocations && (
                      <Tooltip title="Remove Level">
                        <MDButton
                          disabled={!deleteLocation}
                          color="error"
                          iconOnly
                          size="small"
                          variant="contained"
                          type="button"
                          onClick={() => {
                            setRemoveLevelModal(true);
                          }}
                          style={{
                            margin: "10px",
                            marginLeft: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
                          }}
                        >
                          <Icon>remove</Icon>
                        </MDButton>
                      </Tooltip>
                    )}

                    {uploadLocations && (
                      <MDBox px={1} mb={-5} mt={0.8}>
                        <CSVLink {...csvLink}>
                          <DownloadButton
                            tooltip="Download Template"
                            type="button"
                            variant="outlined"
                            color="error"
                            iconOnly
                            size="small"
                          >
                            <Icon>download</Icon>
                          </DownloadButton>
                        </CSVLink>
                      </MDBox>
                    )}

                    {!uploadCsvFilter && (
                      <MDBox color="text" px={1} mb={-5} mt={0.8}>
                        <UploadButton
                          tooltip="Upload CSV"
                          disabled={!uploadLocations}
                          type="button"
                          variant="outlined"
                          color="info"
                          iconOnly
                          size="small"
                          onClick={uploadCsvFilterHandler}
                        >
                          <Icon>upload</Icon>
                        </UploadButton>
                      </MDBox>
                    )}

                    {downloadLocations ? (
                      <MDBox px={1} mb={-5} mt={0.8}>
                        <CSVLink {...csvLink2}>
                          <DownloadDataButton
                            tooltip="Download list"
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                            size="small"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                      </MDBox>
                    ) : (
                      ""
                    )}
                    {uploadCsvFilter && (
                      <MDBox
                        display="flex"
                        alignItems="center"
                        flexWrap="wrap"
                        sx={{
                          mt: 1,
                          ml: { xs: 1, sm: 2, md: 3 },
                          gap: 1,
                          width: "60%",
                        }}
                      >
                        <input
                          className="choose_file"
                          style={{
                            marginTop: "0.6rem",
                            // keep input compact on small screens
                            minWidth: 160,
                            maxWidth: "60%",
                          }}
                          type="file"
                          accept=".csv"
                          onChange={(e) => {
                            setUploadCsvData(e.target.files[0]);
                          }}
                        />

                        <MDButton
                          disabled={
                            !uploadCsvData?.name ||
                            uploadCsvData?.type !== "text/csv"
                          }
                          variant="contained"
                          color="info"
                          style={{
                            marginTop: "0.9rem",
                            whiteSpace: "nowrap",
                          }}
                          type="button"
                          onClick={uploadCsvHandler}
                        >
                          UPLOAD
                        </MDButton>

                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            size="small"
                            color="inherit"
                            onClick={uploadCsvFilterCloseHandler}
                            sx={{
                              mt: "0.6rem",
                              ml: 0.5,
                              bgcolor: "error.main",
                              color: "common.white",
                              "&:hover": { bgcolor: "error.dark" },
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>

                        {/* helper text moves to full width below controls on small screens */}
                        <MDBox sx={{ width: "60%", mt: 0.5 }}>
                          <span
                            style={{
                              color: "red",
                              fontSize: "14px",
                              marginLeft: 4,
                              fontStyle: "italic",
                            }}
                          >
                            <strong>*</strong> Please upload{" "}
                            <strong>".csv"</strong> file only
                          </span>
                        </MDBox>
                      </MDBox>
                    )}
                    <MDBox
                      marginLeft={{ xs: "-560px", lg: "300px" }}
                      display="flex"
                    >
                      <MDButton
                        variant="outlined"
                        type="button"
                        style={{
                          cursor: "auto",
                          margin: "10px",
                          float: "right",
                          marginRight: "1.5rem",
                          marginLeft: "1rem",
                          backgroundColor: "#28B463",
                          color: "white",
                        }}
                      >
                        Empty:-{" "}
                        {locationsByWarehouse.locations.data
                          ? locationsByWarehouse.locations.data[0]
                              .globalEmptyCount
                          : ""}
                      </MDButton>
                      <MDButton
                        variant="contained"
                        type="button"
                        style={{
                          float: "right",
                          margin: "10px",
                          cursor: "auto",
                          backgroundColor: "#B03A2E",
                          color: "white",
                        }}
                      >
                        Occupied:-{" "}
                        {locationsByWarehouse.locations.data
                          ? locationsByWarehouse.locations.data[0]
                              .globalOccupiedCount
                          : ""}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDTypography
                variant="h5"
                style={{
                  marginLeft: "1.5rem",
                }}
              >
                <span
                  style={{
                    color: "#133337",
                    fontWeight: 800,
                  }}
                >
                  WareHouse Name / Code:-
                </span>
                <span style={{ color: "#133337", fontWeight: 400 }}>
                  {!loading2 ? (
                    <>
                      {warehouseNameHeading} / {warehouseCodeHeading}
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20rem",
                        marginTop: "-2rem",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )}
                </span>
              </MDTypography>
              {/* <MDBox display="flex">
                <MDBox
                  width={{ xs: "250px", lg: "300px" }}
                  style={{ marginLeft: "28px", marginTop: "20px" }}
                >
                  <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                    {levelsByWarehouseReducer.levelsByWarehouse.data
                      ? levelsByWarehouseReducer.levelsByWarehouse.data[0]
                          .rltName
                      : ""}
                  </MDTypography>
                  <Select
                    placeholder="Select"
                    className="select-css"
                    value={zonesListByWarehouseSelected}
                    options={zonesListByWarehouseOptions}
                    onChange={handleChangeZonesListByWarehouse}
                    autoComplete="off"
                    maxMenuHeight={130}
                  />
                </MDBox>
                <MDBox
                  width={{ xs: "250px", lg: "300px" }}
                  style={{ marginLeft: "10px", marginTop: "20px" }}
                >
                  <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                    {levelsByWarehouseReducer.levelsByWarehouse.data
                      ? levelsByWarehouseReducer.levelsByWarehouse.data[1]
                          .rltName
                      : ""}
                  </MDTypography>
                  <Select
                    isClearable
                    placeholder="Select"
                    className="select-css"
                    value={sectionsListByZoneSelected}
                    options={sectionsListByZoneOptions}
                    onChange={handleChangeSectionsListByZone}
                    autoComplete="off"
                    maxMenuHeight={130}
                  />
                </MDBox>
              </MDBox> */}
              <>
                {!loading ? (
                  <>
                    {levelOptions.length === 4 &&
                      warehouseLocations?.map((zone) => (
                        <Grid mb={1}>
                          {!zone.data && (
                            <span
                              style={{
                                marginTop: "0px",
                                marginLeft: "20px",
                                marginRight: "20px",
                                color: "#133337",
                                fontWeight: 800,
                                border: "2px solid #F1C40F",
                                borderRadius: "5px",
                                padding: "5px",
                              }}
                            >
                              {zone?.locationName}
                            </span>
                          )}
                          {zone?.data?.map((section) => (
                            <Grid>
                              {!section.data && (
                                <MDTypography
                                  variant="h5"
                                  style={{
                                    marginTop: "1.5rem",
                                    marginLeft: "20px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#133337",
                                      fontWeight: 800,
                                      border: "2px solid #F1C40F",
                                      borderRadius: "5px",
                                      padding: "5px",
                                    }}
                                  >
                                    {zone?.locationName}
                                  </span>{" "}
                                  <span style={{ fontWeight: 900 }}>/</span>{" "}
                                  <span
                                    style={{
                                      color: "#133337",
                                      fontWeight: 500,
                                      border: "2px solid #6495ED",
                                      borderRadius: "5px",
                                      padding: "5px",
                                    }}
                                  >
                                    {section?.locationName}
                                    {/* {section?.locationName && `<hr />`} */}
                                  </span>{" "}
                                </MDTypography>
                              )}
                              {section?.data?.map((rack) => (
                                <Grid
                                  style={{
                                    border: "1px solid grey",
                                    borderRadius: 10,
                                    margin: "5px",
                                    paddingRight: "15px",
                                  }}
                                >
                                  <MDTypography
                                    variant="h5"
                                    style={{
                                      marginTop: "1.5rem",
                                      marginLeft: "20px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#133337",
                                        fontWeight: 800,
                                        border: "2px solid #F1C40F",
                                        borderRadius: "5px",
                                        padding: "5px",
                                      }}
                                    >
                                      {zone?.locationName}
                                    </span>{" "}
                                    <span style={{ fontWeight: 900 }}>/</span>{" "}
                                    <span
                                      style={{
                                        color: "#133337",
                                        fontWeight: 500,
                                        border: "2px solid #6495ED",
                                        borderRadius: "5px",
                                        padding: "5px",
                                      }}
                                    >
                                      {section?.locationName}
                                    </span>{" "}
                                    <span style={{ fontWeight: 900 }}>/</span>{" "}
                                    <span
                                      style={{
                                        color: "#440f2b",
                                        fontWeight: 400,
                                        border: "2px solid #800080",
                                        borderRadius: "5px",
                                        padding: "5px",
                                      }}
                                    >
                                      {rack?.locationName}
                                    </span>
                                  </MDTypography>

                                  <Grid
                                    display="flex"
                                    container
                                    spacing={2}
                                    mt={2}
                                    ml={1}
                                    mr={2}
                                  >
                                    <Grid
                                      ml={0.5}
                                      mt={0.2}
                                      mr={2}
                                      display="flex"
                                      container
                                      spacing={2}
                                    >
                                      {rack?.data?.map((location) => (
                                        <div
                                          className={`masterStoreItem ${
                                            location.isEmpty === 1
                                              ? `badge-success`
                                              : `badge-danger`
                                          }`}
                                        >
                                          {location.isEmpty === 0 && (
                                            <Button
                                              variant="contained"
                                              style={{
                                                margin: "10px",
                                                marginRight: "4.5px",
                                                backgroundColor: "#B03A2E",
                                                color: "white",
                                                position: "relative",
                                                height: 36,
                                                minWidth: 72,
                                                borderRadius: 8,
                                              }}
                                              title={`${
                                                location.locationName
                                              }: ${clampPct(
                                                location.percent,
                                              )}% filled · ${
                                                100 - clampPct(location.percent)
                                              }% empty`}
                                              onClick={() => {
                                                setLocationName(
                                                  location.locationName,
                                                );
                                                getItemByLocation(
                                                  location.locationId,
                                                  jwtToken,
                                                );
                                                handleOpenItemDetailsModal();
                                              }}
                                            >
                                              {location.locationName}

                                              {/* thin progress track */}
                                              <span
                                                aria-hidden
                                                style={{
                                                  position: "absolute",
                                                  left: 0,
                                                  bottom: 0,
                                                  width: "100%",
                                                  height: 6,
                                                  borderRadius: 8,
                                                  background:
                                                    "rgba(255,255,255,0.25)",
                                                }}
                                              />
                                              {/* thin progress fill */}
                                              <span
                                                aria-hidden
                                                style={{
                                                  position: "absolute",
                                                  left: 0,
                                                  bottom: 0,
                                                  width: `${clampPct(
                                                    location.percent,
                                                  )}%`,
                                                  height: 6,
                                                  borderRadius: 8,
                                                  background: "#fff",
                                                  transition:
                                                    "width 200ms ease",
                                                }}
                                              />
                                            </Button>
                                          )}
                                          {location.isEmpty === 1 && (
                                            <MDButton
                                              type="button"
                                              variant="contained"
                                              style={{
                                                margin: "10px",
                                                marginRight: "4.5px",
                                                cursor: "auto",
                                                backgroundColor: "#28B463",
                                                color: "white",
                                                position: "relative",
                                                height: 36,
                                                minWidth: 72,
                                                borderRadius: 8,
                                              }}
                                              title={`${
                                                location.locationName
                                              }: ${clampPct(
                                                location.percent,
                                              )}% filled · ${
                                                100 - clampPct(location.percent)
                                              }% empty`}
                                            >
                                              {location.locationName}

                                              {/* thin progress track */}
                                              <span
                                                aria-hidden
                                                style={{
                                                  position: "absolute",
                                                  left: 0,
                                                  bottom: 0,
                                                  width: "100%",
                                                  height: 6,
                                                  background:
                                                    "rgba(255,255,255,0.25)",
                                                }}
                                              />
                                              {/* thin progress fill */}
                                              <span
                                                aria-hidden
                                                style={{
                                                  position: "absolute",
                                                  left: 0,
                                                  bottom: 0,
                                                  width: `${clampPct(
                                                    location.percent,
                                                  )}%`,
                                                  height: 3,
                                                  background: "#fff",
                                                  transition:
                                                    "width 200ms ease",
                                                }}
                                              />
                                            </MDButton>
                                          )}
                                        </div>
                                      ))}

                                      <div
                                        onClick={() => {
                                          handleAddLocationModal(rack);
                                        }}
                                      >
                                        <Tooltip title="Add Location">
                                          <AddCircleIcon
                                            fontSize="large"
                                            color="info"
                                            style={{
                                              width: "30px",
                                              marginTop: "10px",
                                              // marginBottom: "-58px",
                                              marginRight: "5px",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </Tooltip>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              ))}
                            </Grid>
                          ))}
                        </Grid>
                      ))}

                    {levelOptions.length === 3 &&
                      warehouseLocations?.map((section) => (
                        // !loading ? (
                        <Grid mb={1}>
                          {!section.data && (
                            <span
                              style={{
                                marginTop: "0px",
                                marginLeft: "20px",
                                marginRight: "20px",
                                color: "#133337",
                                fontWeight: 800,
                                border: "2px solid #F1C40F",
                                borderRadius: "5px",
                                padding: "5px",
                              }}
                            >
                              {section?.locationName}
                            </span>
                          )}
                          {section?.data?.map((rack) => (
                            <Grid
                              style={{
                                border: "1px solid grey",
                                borderRadius: 10,
                                margin: "5px",
                                paddingRight: "15px",
                              }}
                            >
                              <MDTypography
                                variant="h5"
                                style={{
                                  marginTop: "1.5rem",
                                  marginLeft: "20px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#133337",
                                    fontWeight: 800,
                                    border: "2px solid #F1C40F",
                                    borderRadius: "5px",
                                    padding: "5px",
                                  }}
                                >
                                  {section?.locationName}
                                </span>{" "}
                                <span style={{ fontWeight: 900 }}>/</span>{" "}
                                <span
                                  style={{
                                    color: "#440f2b",
                                    fontWeight: 500,
                                    border: "2px solid #6495ED",
                                    borderRadius: "5px",
                                    padding: "5px",
                                  }}
                                >
                                  {rack?.locationName}
                                </span>
                              </MDTypography>

                              <Grid
                                display="flex"
                                container
                                spacing={2}
                                mt={2}
                                ml={1}
                                mr={2}
                              >
                                <Grid
                                  ml={0.5}
                                  mt={0.2}
                                  mr={2}
                                  display="flex"
                                  container
                                  spacing={2}
                                >
                                  {rack?.data?.map((location) => (
                                    <div
                                      className={`masterStoreItem ${
                                        location.isEmpty === 1
                                          ? `badge-success`
                                          : `badge-danger`
                                      }`}
                                    >
                                      {location.isEmpty === 0 && (
                                        <Button
                                          variant="contained"
                                          style={{
                                            margin: "10px",
                                            marginRight: "4.5px",
                                            backgroundColor: "#B03A2E",
                                            color: "white",
                                          }}
                                          onClick={() => {
                                            // setLocationId(location.locationId);
                                            setLocationName(
                                              location.locationName,
                                            );
                                            getItemByLocation(
                                              location.locationId,
                                              jwtToken,
                                            );
                                            handleOpenItemDetailsModal();
                                          }}
                                        >
                                          {location.locationName}
                                        </Button>
                                      )}
                                      {location.isEmpty === 1 && (
                                        <MDButton
                                          type="button"
                                          variant="contained"
                                          style={{
                                            margin: "10px",
                                            marginRight: "4.5px",
                                            cursor: "auto",
                                            backgroundColor: "#28B463",
                                            color: "white",
                                          }}
                                        >
                                          {location.locationName}
                                        </MDButton>
                                      )}
                                    </div>
                                  ))}

                                  <div
                                    onClick={() => {
                                      handleAddLocationModal(rack);
                                    }}
                                  >
                                    {addDirectLocation && (
                                      <Tooltip title="Add Location">
                                        <AddCircleIcon
                                          fontSize="large"
                                          color="info"
                                          style={{
                                            width: "30px",
                                            marginTop: "10px",
                                            // marginBottom: "-58px",
                                            marginRight: "5px",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          ))}
                        </Grid>
                      ))}

                    {levelOptions.length === 2 &&
                      warehouseLocations?.map((rack) => (
                        // !loading ? (
                        <Grid mb={1}>
                          {!rack.data && (
                            <span
                              style={{
                                marginTop: "0px",
                                marginLeft: "20px",
                                marginRight: "20px",
                                color: "#133337",
                                fontWeight: 800,
                                border: "2px solid #F1C40F",
                                borderRadius: "5px",
                                padding: "5px",
                              }}
                            >
                              {rack?.locationName}
                            </span>
                          )}
                          {rack.data && (
                            <Grid
                              style={{
                                border: "1px solid grey",
                                borderRadius: 10,
                                margin: "5px",
                                paddingRight: "15px",
                              }}
                            >
                              <MDTypography
                                variant="h5"
                                style={{
                                  marginTop: "1.5rem",
                                  marginLeft: "20px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#440f2b",
                                    fontWeight: 800,
                                    border: "2px solid #F1C40F",
                                    borderRadius: "5px",
                                    padding: "5px",
                                  }}
                                >
                                  {rack?.locationName}
                                </span>
                              </MDTypography>

                              <Grid
                                display="flex"
                                container
                                spacing={2}
                                mt={2}
                                ml={1}
                                mr={2}
                              >
                                <Grid
                                  ml={0.5}
                                  mt={0.2}
                                  mr={2}
                                  display="flex"
                                  container
                                  spacing={2}
                                >
                                  {rack?.data?.map((location) => (
                                    <div
                                      className={`masterStoreItem ${
                                        location.isEmpty === 1
                                          ? `badge-success`
                                          : `badge-danger`
                                      }`}
                                    >
                                      {location.isEmpty === 0 && (
                                        <Button
                                          variant="contained"
                                          style={{
                                            margin: "10px",
                                            marginRight: "4.5px",
                                            backgroundColor: "#B03A2E",
                                            color: "white",
                                          }}
                                          onClick={() => {
                                            // setLocationId(location.locationId);
                                            setLocationName(
                                              location.locationName,
                                            );
                                            getItemByLocation(
                                              location.locationId,
                                              jwtToken,
                                            );
                                            handleOpenItemDetailsModal();
                                          }}
                                        >
                                          {location.locationName}
                                        </Button>
                                      )}
                                      {location.isEmpty === 1 && (
                                        <MDButton
                                          type="button"
                                          variant="contained"
                                          style={{
                                            margin: "10px",
                                            marginRight: "4.5px",
                                            cursor: "auto",
                                            backgroundColor: "#28B463",
                                            color: "white",
                                          }}
                                        >
                                          {location.locationName}
                                        </MDButton>
                                      )}
                                    </div>
                                  ))}

                                  <div
                                    onClick={() => {
                                      handleAddLocationModal(rack);
                                    }}
                                  >
                                    <Tooltip title="Add Location">
                                      <AddCircleIcon
                                        fontSize="large"
                                        color="info"
                                        style={{
                                          width: "30px",
                                          marginTop: "10px",
                                          // marginBottom: "-58px",
                                          marginRight: "5px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      ))}
                    {levelOptions.length === 1 && (
                      <Grid mb={1}>
                        <Grid
                          style={{
                            border: "1px solid grey",
                            borderRadius: 10,
                            margin: "5px",
                            paddingRight: "15px",
                          }}
                        >
                          <Grid
                            display="flex"
                            container
                            spacing={2}
                            mt={2}
                            ml={1}
                            mr={2}
                          >
                            <Grid
                              ml={0.5}
                              mt={0.2}
                              mr={2}
                              display="flex"
                              container
                              spacing={2}
                            >
                              {warehouseLocations?.map((location) => (
                                <div
                                  className={`masterStoreItem ${
                                    location.isEmpty === 1
                                      ? `badge-success`
                                      : `badge-danger`
                                  }`}
                                >
                                  {location.isEmpty === 0 && (
                                    <Button
                                      variant="contained"
                                      style={{
                                        margin: "10px",
                                        marginRight: "4.5px",
                                        backgroundColor: "#B03A2E",
                                        color: "white",
                                      }}
                                      onClick={() => {
                                        // setLocationId(location.locationId);
                                        setLocationName(location.locationName);
                                        getItemByLocation(
                                          location.locationId,
                                          jwtToken,
                                        );
                                        handleOpenItemDetailsModal();
                                      }}
                                    >
                                      {location.locationName}
                                    </Button>
                                  )}
                                  {location.isEmpty === 1 && (
                                    <MDButton
                                      type="button"
                                      variant="contained"
                                      style={{
                                        margin: "10px",
                                        marginRight: "4.5px",
                                        cursor: "auto",
                                        backgroundColor: "#28B463",
                                        color: "white",
                                      }}
                                    >
                                      {location.locationName}
                                    </MDButton>
                                  )}
                                </div>
                              ))}

                              <div
                                onClick={() => {
                                  handleAddLocationModal();
                                }}
                              >
                                <Tooltip title="Add Location">
                                  <AddCircleIcon
                                    fontSize="large"
                                    color="info"
                                    style={{
                                      width: "30px",
                                      marginTop: "10px",
                                      // marginBottom: "-58px",
                                      marginRight: "5px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Tooltip>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "100px",
                      marginBottom: "100px",
                    }}
                  >
                    <CircularProgress color="info" />
                  </div>
                )}
                <div>
                  <Modal
                    open={addLocationModal}
                    onClose={handleAddLocationModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <MDCard sx={style}>
                      <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                        <MDTypography
                          variant="h4"
                          fontWeight="medium"
                          flexGrow={1}
                        >
                          Add Location
                        </MDTypography>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseAddLocationModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                      <hr
                        style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                      />
                      <MDBox pt={1} pb={3} px={3}>
                        <MDBox
                          component="form"
                          role="form"
                          onSubmit={formik.handleSubmit}
                        >
                          <MDBox>
                            <MDBox mb={2}>
                              <MDTypography variant="h6">Location</MDTypography>

                              <MDInput
                                type="text"
                                name="location"
                                fullWidth
                                autoComplete="off"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.location}
                                error={
                                  formik.touched.location &&
                                  formik.errors.location &&
                                  true
                                }
                              />
                              {formik.touched.location &&
                                formik.errors.location && (
                                  <TextError msg={formik.errors.location} />
                                )}
                            </MDBox>

                            <MDBox>
                              <Collapse in={isErrorAddLocation}>
                                <Alert
                                  severity="error"
                                  action={
                                    <IconButton
                                      aria-label="close"
                                      color="inherit"
                                      size="small"
                                      onClick={() => {
                                        setIsErrorAddLocation(false);
                                      }}
                                    >
                                      <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                  }
                                >
                                  {isErrorMsgAddLocation}
                                </Alert>
                              </Collapse>
                              <Collapse in={isSuccessAddLocation}>
                                <Alert
                                  severity="success"
                                  action={
                                    <IconButton
                                      aria-label="close"
                                      color="inherit"
                                      size="small"
                                      onClick={() => {
                                        setIsSuccessAddLocation(false);
                                      }}
                                    >
                                      <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                  }
                                >
                                  Location added successfully
                                </Alert>
                              </Collapse>
                            </MDBox>
                            <div className="mt-3">
                              <MDButton
                                type="submit"
                                variant="gradient"
                                color="info"
                                fullWidth
                              >
                                Add Location
                              </MDButton>
                            </div>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDCard>
                  </Modal>
                </div>
                <Modal
                  open={addZoneModal}
                  onClose={handleAddZoneModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Add Level
                      </MDTypography>
                      <MDBox>
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleAddZoneModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForAddZone.handleSubmit}
                      >
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Level{" "}
                          </MDTypography>

                          <Select
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="level"
                            onBlur={() => {
                              formikForAddZone.handleBlur({
                                target: { name: "level" },
                              });
                            }}
                            value={levelSelected}
                            options={levelOptions}
                            onChange={(selectedOption) => {
                              handleLevelChange(selectedOption);
                              formikForAddZone.handleChange("level")(
                                selectedOption.label,
                              );
                            }}
                          />
                          {formikForAddZone.touched.level &&
                            formikForAddZone.errors.level && (
                              <TextError msg={formikForAddZone.errors.level} />
                            )}
                        </MDBox>

                        {levelSelected.value !== "" && (
                          <>
                            {levelSelected.value >= 2 &&
                              levelOptions[0]?.value === 1 && (
                                <MDBox mb={1}>
                                  <MDTypography
                                    variant="h6"
                                    style={{ fontWeight: "500" }}
                                  >
                                    {levelOptions[0]?.label}
                                  </MDTypography>

                                  <Select
                                    className="select-css"
                                    maxMenuHeight={130}
                                    placeholder="Choose one..."
                                    name="level1"
                                    onBlur={() => {
                                      formikForAddZone.handleBlur({
                                        target: { name: "level1" },
                                      });
                                    }}
                                    value={zoneIdSelected}
                                    options={level1Options}
                                    onChange={(selectedOption) => {
                                      handleZoneIdChange(selectedOption);
                                      formikForAddZone.handleChange("level1")(
                                        selectedOption.label,
                                      );
                                      getLevel2ByLevel(
                                        warehouseId,
                                        selectedOption?.value,
                                        jwtToken,
                                      );

                                      getLevel3ByLevel(
                                        warehouseId,
                                        selectedOption?.value,
                                        jwtToken,
                                      );
                                    }}
                                  />
                                  {formikForAddZone.touched.level1 &&
                                    formikForAddZone.errors.level1 && (
                                      <TextError
                                        msg={formikForAddZone.errors.level1}
                                      />
                                    )}
                                </MDBox>
                              )}
                            {levelSelected.value >= 3 &&
                              (levelOptions[0]?.value == 2 ||
                                levelOptions[1]?.value == 2) && (
                                <>
                                  <MDBox mb={1}>
                                    <MDTypography
                                      variant="h6"
                                      style={{ fontWeight: "500" }}
                                    >
                                      {(levelOptions[0]?.value == 2 &&
                                        levelOptions[0]?.label) ||
                                        (levelOptions[1]?.value == 2 &&
                                          levelOptions[1]?.label)}
                                    </MDTypography>

                                    <Select
                                      className="select-css"
                                      isDisabled={
                                        levelOptions[0]?.value == 1 &&
                                        !zoneIdSelected
                                          ? true
                                          : false ||
                                            !(
                                              levelOptions[0]?.value === 2 ||
                                              levelOptions[1]?.value === 2
                                            )
                                      }
                                      maxMenuHeight={130}
                                      placeholder="Choose one..."
                                      name="level2"
                                      onBlur={() => {
                                        formikForAddZone.handleBlur({
                                          target: { name: "level2" },
                                        });
                                      }}
                                      value={sectionIdSelected}
                                      options={level2Options}
                                      onChange={(selectedOption) => {
                                        handleSectionIdChange(selectedOption);
                                        formikForAddZone.handleChange("level2")(
                                          selectedOption.label,
                                        );
                                        getLevel3ByLevel(
                                          warehouseId,
                                          selectedOption?.value,
                                          jwtToken,
                                        );
                                      }}
                                    />
                                    {formikForAddZone.touched.level2 &&
                                      formikForAddZone.errors.level2 && (
                                        <TextError
                                          msg={formikForAddZone.errors.level2}
                                        />
                                      )}
                                  </MDBox>
                                </>
                              )}
                            {levelSelected.value === 4 &&
                              (levelOptions[0]?.value == 3 ||
                                levelOptions[1]?.value == 3 ||
                                levelOptions[2]?.value == 3) && (
                                <MDBox mb={1}>
                                  <MDTypography
                                    variant="h6"
                                    style={{ fontWeight: "500" }}
                                  >
                                    {(levelOptions[0]?.value == 3 &&
                                      levelOptions[0]?.label) ||
                                      (levelOptions[1]?.value == 3 &&
                                        levelOptions[1]?.label) ||
                                      (levelOptions[2]?.value == 3 &&
                                        levelOptions[2]?.label)}
                                  </MDTypography>

                                  <Select
                                    className="select-css"
                                    isDisabled={
                                      ((levelOptions[0]?.value == 2 ||
                                        levelOptions[1]?.value == 2) &&
                                      !sectionIdSelected
                                        ? true
                                        : false) ||
                                      !(
                                        levelOptions[0]?.value === 3 ||
                                        levelOptions[1]?.value === 3 ||
                                        levelOptions[2]?.value === 3
                                      )
                                    }
                                    maxMenuHeight={130}
                                    placeholder="Choose One..."
                                    name="level3"
                                    value={rackIdSelected}
                                    options={level3Options}
                                    onChange={(selectedOption) => {
                                      handleRackIdChange(selectedOption);
                                      getLevel4ByLevel(
                                        warehouseId,
                                        selectedOption?.value,
                                        jwtToken,
                                      );
                                      // formikForFilter.handleChange(
                                      //   "zoneCategory"
                                      // )(selectedOption.value);
                                    }}
                                  />
                                  {formikForAddZone.errors.level3 && (
                                    <TextError
                                      msg={formikForAddZone.errors.level3}
                                    />
                                  )}
                                </MDBox>
                              )}

                            {levelSelected.value && (
                              <MDBox mb={2}>
                                <MDTypography
                                  variant="h6"
                                  style={{ fontWeight: 500 }}
                                >
                                  {levelSelected.label} Name
                                </MDTypography>
                                <MDInput
                                  type="text"
                                  name="location"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForAddZone.handleBlur}
                                  onChange={formikForAddZone.handleChange}
                                  value={formikForAddZone.values.location}
                                  error={
                                    formikForAddZone.touched.location &&
                                    formikForAddZone.errors.location &&
                                    true
                                  }
                                />
                                {formikForAddZone.touched.location &&
                                  formikForAddZone.errors.location && (
                                    <TextError
                                      msg={formikForAddZone.errors.location}
                                    />
                                  )}
                              </MDBox>
                            )}
                          </>
                        )}
                        <MDBox>
                          <Collapse in={isErrorAddZone}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorAddZone(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {createErrorMsg}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessAddZone}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessAddZone(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Level added successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="info"
                            fullWidth
                            type="submit"
                            disabled={
                              !formikForAddZone.isValid ||
                              !levelSelected ||
                              // (levelOptions.length === 4 &&
                              //   !(
                              //     zoneIdSelected &&
                              //     sectionIdSelected &&
                              //     rackIdSelected
                              //   )) ||
                              (levelOptions[0]?.value === 1 &&
                                levelSelected?.value !== 1 &&
                                !zoneIdSelected) ||
                              ((levelOptions[0]?.value === 2 ||
                                levelOptions[1]?.value === 2) &&
                                (levelSelected?.value === 3 ||
                                  levelSelected?.value === 4) &&
                                !sectionIdSelected) ||
                              ((levelOptions[0]?.value === 3 ||
                                levelOptions[1]?.value === 3 ||
                                levelOptions[2]?.value === 3) &&
                                levelSelected?.value === 4 &&
                                !rackIdSelected)
                              // ||
                              //  ((levelOptions[0]?.value ||
                              //   levelOptions[1]?.value ||
                              //   levelOptions[2]?.value || levelOptions[3]?.value) === 4 &&
                              //   levelSelected?.value !== (4 || 3 || 2 || 1) &&
                              //   !locationIdSelected)

                              // ||
                              // (levelSelected.value === 3 &&
                              //   !zoneIdSelected &&
                              //   !sectionIdSelected) ||
                              // (levelSelected.value === 4 &&
                              //   !zoneIdSelected &&
                              //   !rackIdSelected) ||
                              // (!zoneIdSelected && !sectionIdSelected) ||
                              // (!rackIdSelected && !sectionIdSelected) ||
                              // (levelSelected.value === 2 && !zoneIdSelected)
                            }
                          >
                            Submit
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>

                <Modal
                  open={removeLevelModal}
                  onClose={handleRemoveLevelModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Remove Level
                      </MDTypography>
                      <MDBox>
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseRemoveLevelModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForRemoveLevel.handleSubmit}
                      >
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Level{" "}
                          </MDTypography>

                          <Select
                            className="select-css"
                            maxMenuHeight={90}
                            placeholder="Choose one..."
                            name="level"
                            onBlur={() => {
                              formikForRemoveLevel.handleBlur({
                                target: { name: "level" },
                              });
                            }}
                            value={levelSelected}
                            options={levelOptions}
                            onChange={(selectedOption) => {
                              handleLevelChange(selectedOption);
                              formikForRemoveLevel.handleChange("level")(
                                selectedOption.label,
                              );
                            }}
                          />
                          {formikForRemoveLevel.touched.level &&
                            formik.errors.level && (
                              <TextError
                                msg={formikForRemoveLevel.errors.level}
                              />
                            )}
                        </MDBox>

                        {levelSelected.value !== "" && (
                          <>
                            {(levelSelected.value === 1 ||
                              levelSelected.value === 2 ||
                              levelSelected.value === 3 ||
                              levelSelected.value === 4) &&
                              levelOptions[0]?.value == 1 && (
                                <MDBox mb={1}>
                                  <MDTypography
                                    variant="h6"
                                    style={{ fontWeight: "500" }}
                                  >
                                    {levelOptions[0]?.label}
                                  </MDTypography>

                                  <Select
                                    className="select-css"
                                    maxMenuHeight={130}
                                    placeholder="Choose one..."
                                    name="level1"
                                    onBlur={() => {
                                      formikForRemoveLevel.handleBlur({
                                        target: { name: "level1" },
                                      });
                                    }}
                                    value={zoneIdSelected}
                                    options={level1Options}
                                    onChange={(selectedOption) => {
                                      handleZoneIdChange(selectedOption);
                                      formikForRemoveLevel.handleChange(
                                        "level1",
                                      )(selectedOption.label);
                                      getLevel2ByLevel(
                                        warehouseId,
                                        selectedOption?.value,
                                        jwtToken,
                                      );

                                      getLevel3ByLevel(
                                        warehouseId,
                                        selectedOption?.value,
                                        jwtToken,
                                      );
                                      getLevel4ByLevel(
                                        warehouseId,
                                        selectedOption?.value,
                                        jwtToken,
                                      );
                                    }}
                                  />
                                  {formikForRemoveLevel.touched.level1 &&
                                    formikForRemoveLevel.errors.level1 && (
                                      <TextError
                                        msg={formikForRemoveLevel.errors.level1}
                                      />
                                    )}
                                </MDBox>
                              )}
                            {(levelSelected.value === 2 ||
                              levelSelected.value === 3 ||
                              levelSelected.value === 4) &&
                              (levelOptions[0]?.value == 2 ||
                                levelOptions[1]?.value == 2) && (
                                <>
                                  <MDBox mb={1}>
                                    <MDTypography
                                      variant="h6"
                                      style={{ fontWeight: "500" }}
                                    >
                                      {(levelOptions[0]?.value == 2 &&
                                        levelOptions[0]?.label) ||
                                        (levelOptions[1]?.value == 2 &&
                                          levelOptions[1]?.label)}
                                    </MDTypography>

                                    <Select
                                      className="select-css"
                                      isDisabled={
                                        (levelOptions[0]?.value == 1 &&
                                          !zoneIdSelected) ||
                                        (levelOptions[0]?.value == 2 &&
                                          !sectionIdSelected)
                                          ? true
                                          : false ||
                                            !(
                                              levelOptions[0]?.value === 2 ||
                                              levelOptions[1]?.value === 2
                                            )
                                      }
                                      maxMenuHeight={130}
                                      placeholder="Choose one..."
                                      name="level2"
                                      onBlur={() => {
                                        formikForRemoveLevel.handleBlur({
                                          target: { name: "level2" },
                                        });
                                      }}
                                      value={sectionIdSelected}
                                      options={level2Options}
                                      onChange={(selectedOption) => {
                                        handleSectionIdChange(selectedOption);
                                        formikForRemoveLevel.handleChange(
                                          "level2",
                                        )(selectedOption.label);
                                        getLevel3ByLevel(
                                          warehouseId,
                                          selectedOption?.value,
                                          jwtToken,
                                        );
                                        getLevel4ByLevel(
                                          warehouseId,
                                          selectedOption?.value,
                                          jwtToken,
                                        );
                                      }}
                                    />
                                    {formikForRemoveLevel.touched.level2 &&
                                      formikForRemoveLevel.errors.level2 && (
                                        <TextError
                                          msg={
                                            formikForRemoveLevel.errors.level2
                                          }
                                        />
                                      )}
                                  </MDBox>
                                </>
                              )}
                            {(levelSelected.value === 4 ||
                              levelSelected.value === 3) &&
                              (levelOptions[0]?.value == 3 ||
                                levelOptions[1]?.value == 3 ||
                                levelOptions[2]?.value == 3) && (
                                <MDBox mb={1}>
                                  <MDTypography
                                    variant="h6"
                                    style={{ fontWeight: "500" }}
                                  >
                                    {(levelOptions[0]?.value == 3 &&
                                      levelOptions[0]?.label) ||
                                      (levelOptions[1]?.value == 3 &&
                                        levelOptions[1]?.label) ||
                                      (levelOptions[2]?.value == 3 &&
                                        levelOptions[2]?.label)}
                                  </MDTypography>

                                  <Select
                                    className="select-css"
                                    isDisabled={
                                      ((levelOptions[0]?.value === 2 ||
                                        levelOptions[1]?.value === 2) &&
                                      !sectionIdSelected
                                        ? true
                                        : false) ||
                                      !(
                                        levelOptions[0]?.value === 3 ||
                                        levelOptions[1]?.value === 3 ||
                                        levelOptions[2]?.value === 3
                                      )
                                    }
                                    maxMenuHeight={130}
                                    placeholder="Choose One..."
                                    name="level3"
                                    value={rackIdSelected}
                                    options={level3Options}
                                    onChange={(selectedOption) => {
                                      handleRackIdChange(selectedOption);
                                      getLevel4ByLevel(
                                        warehouseId,
                                        selectedOption?.value,
                                        jwtToken,
                                      );
                                      // formikForFilter.handleChange(
                                      //   "zoneCategory"
                                      // )(selectedOption.value);
                                    }}
                                  />
                                  {formikForRemoveLevel.errors.level3 && (
                                    <TextError
                                      msg={formikForRemoveLevel.errors.level3}
                                    />
                                  )}
                                </MDBox>
                              )}

                            {levelSelected.value === 4 &&
                              (levelOptions[0]?.value == 4 ||
                                levelOptions[1]?.value == 4 ||
                                levelOptions[2]?.value == 4 ||
                                levelOptions[3]?.value == 4) && (
                                <MDBox mb={2}>
                                  <MDTypography
                                    variant="h6"
                                    style={{ fontWeight: 500 }}
                                  >
                                    {levelSelected.label}
                                  </MDTypography>
                                  <Select
                                    isClearable
                                    isDisabled={
                                      ((levelOptions[0]?.value == 3 ||
                                        levelOptions[1]?.value == 3 ||
                                        levelOptions[2]?.value == 3) &&
                                      !rackIdSelected
                                        ? true
                                        : false) ||
                                      !(
                                        levelOptions[0]?.value === 4 ||
                                        levelOptions[1]?.value === 4 ||
                                        levelOptions[2]?.value === 4 ||
                                        levelOptions[3]?.value === 4
                                      )
                                    }
                                    className="select-css"
                                    maxMenuHeight={130}
                                    placeholder="Choose one..."
                                    name="location"
                                    value={locationIdSelected}
                                    options={level4Options}
                                    onChange={(selectedOption) => {
                                      handleLocationIdChange(selectedOption);
                                    }}
                                  />
                                  {formikForRemoveLevel.touched.location &&
                                    formikForRemoveLevel.errors.location && (
                                      <TextError
                                        msg={
                                          formikForRemoveLevel.errors.location
                                        }
                                      />
                                    )}
                                </MDBox>
                              )}
                          </>
                        )}
                        <MDBox>
                          <Collapse in={isErrorRemoveLevel}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorRemoveLevel(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {deleteErrorMsg}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessRemoveLevel}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessRemoveLevel(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Level deleted successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="error"
                            fullWidth
                            type="submit"
                            disabled={
                              !formikForRemoveLevel.isValid ||
                              !levelSelected ||
                              (levelOptions[0]?.value === 1 &&
                                (levelSelected?.value === 1 ||
                                  levelSelected?.value === 2 ||
                                  levelSelected?.value === 3 ||
                                  levelSelected?.value === 4) &&
                                !zoneIdSelected) ||
                              ((levelOptions[0]?.value === 2 ||
                                levelOptions[1]?.value === 2) &&
                                (levelSelected?.value === 2 ||
                                  levelSelected?.value === 3 ||
                                  levelSelected?.value === 4) &&
                                !sectionIdSelected) ||
                              ((levelOptions[0]?.value === 3 ||
                                levelOptions[1]?.value === 3 ||
                                levelOptions[2]?.value === 3) &&
                                (levelSelected?.value === 3 ||
                                  levelSelected?.value === 4) &&
                                !rackIdSelected) ||
                              ((levelOptions[0]?.value === 4 ||
                                levelOptions[1]?.value === 4 ||
                                levelOptions[2]?.value === 4 ||
                                levelOptions[3]?.value === 4) &&
                                levelSelected?.value === 4 &&
                                !locationIdSelected)
                            }
                          >
                            Submit
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <div>
                  <Modal
                    open={itemDetailsModal}
                    onClose={handleOpenItemDetailsModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <MDCard sx={styleForZoneModal}>
                      <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                        <MDTypography
                          variant="h4"
                          fontWeight="medium"
                          flexGrow={1}
                        >
                          {locationName}
                        </MDTypography>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleOpenItemDetailsModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>

                      <MDBox pt={1} pb={3} px={3}>
                        <DataTable
                          table={{ columns, rows }}
                          isSorted={true}
                          tableSearch={true}
                          entriesPerPage={{
                            defaultValue: 5,
                            entries: [5, 10, 15, 20, 25, 30],
                          }}
                          showTotalEntries={true}
                          noEndBorder
                          options={{ draggable: false }}
                        />
                      </MDBox>
                    </MDCard>
                  </Modal>
                </div>
              </>
              <ToastContainer />
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    locationsByWarehouse: state.locationsByWarehouse,
    downloadLocationsByWarehouseReducer:
      state.downloadLocationsByWarehouseReducer,
    locationsByWarehouseAndZone: state.locationsByWarehouseAndZone,
    item: state.item,

    warehouseById: state.warehouseById,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,

    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getZonesByWarehouseForViewLocationReducer:
      state.getZonesByWarehouseForViewLocationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getLocationsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLocationsByWarehouse(warehouseId, jwtToken)),

    downloadLocationsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(downloadLocationsByWarehouse(warehouseId, jwtToken)),

    addLocationToWarehouse: (payload, jwtToken) =>
      dispatch(addLocationToWarehouse(payload, jwtToken)),
    deleteLocation: (locationId, warehouseId, jwtToken) =>
      dispatch(deleteLocation(locationId, warehouseId, jwtToken)),
    getItemByLocation: (locationId, jwtToken) =>
      dispatch(getItemByLocation(locationId, jwtToken)),
    getAllCategories: () => dispatch(getAllCategories()),

    getWarehouseById: (id, jwtToken) =>
      dispatch(getWarehouseById(id, jwtToken)),
    uploadExcelForCreatingZoneRackLocation: (payload, jwtToken) =>
      dispatch(uploadExcelForCreatingZoneRackLocation(payload, jwtToken)),

    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getZonesByWarehouseForViewLocation: (warehouseId, jwtToken) =>
      dispatch(getZonesByWarehouseForViewLocation(warehouseId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewLocation);
